import { createAction, props } from '@ngrx/store'

const prefix = '[auth]'

export const login_success = createAction(`${prefix} login_success`, props<{ bearer_token: string }>())
export const login_failed = createAction(`${prefix} login_failed`, props<{ bearer_token: string }>())

export const start_logout = createAction(`${prefix} start_logout`, props<any>())
export const logout_success = createAction(`${prefix} logout_success`, props<{ data: any }>())
export const logout_failed = createAction(`${prefix} logout_failed`, props<{ data: any }>())

export const start_sso_login = createAction('start_sso_login', props<{ access_token: string }>())
export const start_support_user_login = createAction('start_support_user_login', props<{token: string}>())
